module.exports = __webpack_public_path__ + "static/img/39.a8484b5b.gif";